import { AxiosResponse } from 'axios'
import * as queryString from 'query-string'

import axiosVerbose from './axios/axiosVerbose'
import ssoRequest from './ssoRequest'

interface IPayload {
  currentSite: string
}

export const autoSignIn = (payload: IPayload) => {
  const data = queryString.stringify(payload)
  return (ssoRequest as Record<string, any>)
    .post(`/api/auto_sign_in`, data, {
      withCredentials: true
    })
    .then((ssoResponse: AxiosResponse) => {
      const { token: ssoToken } = ssoResponse.data
      if (ssoToken) {
        return axiosVerbose
          .post('/jwt_session', { token: ssoToken })
          .then(jwtResponse => {
            const { token: jwtToken } = jwtResponse.data
            return jwtToken ? Promise.resolve(jwtToken) : Promise.reject()
          })
      } else {
        return Promise.reject()
      }
    })
}
